import React from 'react'
import { useShowContext, SimpleShowLayout, Show, useTranslate, Loading, Error } from 'react-admin'
import { Grid, Container, Typography } from '@mui/material'
import { CardCommon } from '../../../uiElements'
import { ShowListElement } from 'src/components/uiElements/CRUD/ShowListElement'
import { CardCrudBottomButtons } from 'src/components/uiElements/CRUD/CardCrudBottomButtons'
import { getDay } from '../reservation/helper/getDay'
import { FormDivider } from 'src/components/uiElements/fields/Divider'

const ShowWrapper = ({ children }) => <Container maxWidth='false'> {children}</Container>

const ShowContent = () => {
  const translate = useTranslate()
  const {
    error, // error returned by dataProvider when it failed to fetch the record. Useful if you want to adapt the view instead of just showing a notification using the `onError` side effect.
    isLoading, // boolean that is true until the record is available for the first time
    record, // record fetched via dataProvider.getOne() based on the id from the location
  } = useShowContext()

  if (isLoading) {
    return <Loading />
  }

  if (error) {
    return <Error />
  }

  return (
    <SimpleShowLayout>
      <CardCommon
        title={translate('ra.entity.due-date-range')}
        actions={<CardCrudBottomButtons btnEdit={true} />}
      >
        <Grid container spacing={3}>
          <ShowListElement label={'ID'} value={record.id} />
          <ShowListElement label={translate('ra.field.name')} value={record.name} />
          <FormDivider show={true} text={translate('ra.field.date_ranges')} />
          {record.date_range_relation?.length ? (
            <>
              {record.date_range_relation?.map((field, index) => (
                <Grid container key={index}>
                  <ShowListElement
                    label={translate('ra.field.datetime_from')}
                    value={field?.date_from ? getDay(field?.date_from, false) : null}
                  />
                  <ShowListElement
                    label={translate('ra.field.datetime_to')}
                    value={field?.date_to ? getDay(field?.date_to, false) : null}
                  />
                  <ShowListElement
                    label={translate('ra.field.final_date')}
                    value={field?.date_final ? getDay(field?.date_final, false) : null}
                  />
                </Grid>
              ))}
            </>
          ) : (
            <Grid item>
              <Typography variant='button'>{translate('ra.message.no_registry')}</Typography>
            </Grid>
          )}
        </Grid>
      </CardCommon>
    </SimpleShowLayout>
  )
}

export const DueDateRangeShow = (props) => {
  return (
    <Show component={ShowWrapper} {...props} className='CrudShowContainer' actions={null}>
      <ShowContent {...props} />
    </Show>
  )
}